import CustomButton from "../../../../../components/CustomButton";
import userRoles from "../../../../../constants/userRoles";
import SvgIcon from "../../../../../helpers/SvgIcon";
import { fetchDownloadCmr } from "../../../../../redux/api/raports.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import { ActiveTransportsDataInterface } from "../../../../../redux/interfaces/transport.interface";
import { setSelectedActiveTransport } from "../../../../../redux/reducer/raports.reducer";
import usePermissions from "../../../../../router/usePermissions";

function ActiveTransportActionButton({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: ActiveTransportsDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const { isAuthorized } = usePermissions();

  const { id_ruta_intranod } = crudData;

  const END_ACTIVE_TRANSPORT = isAuthorized(userRoles.END_ACTIVE_TRANSPORT);

  const handleDownloadCmr = () => {
    if (id_ruta_intranod && itemId) {
      dispatch(
        fetchDownloadCmr({
          idTransport: itemId,
        }),
      );
    }
  };

  const handleEndTransport = () => {
    dispatch(setSelectedActiveTransport(crudData));
  };

  return (
    <div>
      {id_ruta_intranod ? (
        <CustomButton
          variant="contained"
          className="mt-1 me-1"
          tooltipTitle="Descarca CMR"
          onClick={handleDownloadCmr}>
          <SvgIcon
            type="DOCUMENT_WITH_DOWNLOAD"
            fill="white"
            className="svg-icon-2"
          />
        </CustomButton>
      ) : (
        <></>
      )}
      {END_ACTIVE_TRANSPORT && (
        <CustomButton
          variant="contained"
          color="error"
          className="mt-1 me-1"
          tooltipTitle="Finalizeaza transportul"
          onClick={handleEndTransport}>
          <SvgIcon type="CLOSE_ICON" fill="white" />
        </CustomButton>
      )}
    </div>
  );
}

export default ActiveTransportActionButton;
